import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import type { AddressFormContent, FormAddress } from '@innogy/common-ui/forms';
import {
  addressFormRenderingToContent,
  AddressFormComponent,
} from '@innogy/common-ui/forms';
import { TrackToolStep } from '@analytics/models';
import type { InnogyComponentRendering } from '@core/jss-models';
import { ScAddressFormInput } from '@innogy/sitecore-forms/models';
import type { ComponentFields } from '@sitecore-jss/sitecore-jss-angular';
import { FormGroupState } from 'ngrx-forms';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';

@Component({
  selector: 'wl-sc-address[formState][fields][trackStep]',
  templateUrl: './sc-address.component.html',
  standalone: true,
  imports: [JssModule, AddressFormComponent],
})
export class ScAddressComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formState!: FormGroupState<FormAddress>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() fields!: ScAddressFormInput;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() trackStep!: TrackToolStep;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() floatingLabels = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() responsive = true;

  rendering!: InnogyComponentRendering & { fields: ScAddressFormInput };

  ngOnInit() {
    // We override the componentName because analytics needs to read the
    // toolname of the generic form and not of the address rendering
    this.rendering = {
      componentName: this.trackStep.toolName,
      fields: {
        ...this.fields,
        componentName: { value: this.trackStep.toolName },
      } as ComponentFields & ScAddressFormInput,
    };
  }

  get addressFormFields(): AddressFormContent {
    return addressFormRenderingToContent(this.rendering);
  }
}
